module.exports = {"title":"Delete ticket","description":"Are you sure you want to delete that ticket?","yes":"Yes","no":"No"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/AlertModalBoca/locales/en.json
// module id = 1198
// module chunks = 0